import moment from "moment";

export const getLink = (content) => {
    let obj = [
      {
        title: 'First Contentful Paint',
        url:
          'https://web.dev/first-contentful-paint/#how-to-improve-your-fcp-score',
      },
      {
        title: 'Speed Index',
        url:
          'https://web.dev/speed-index/#how-to-improve-your-speed-index-score',
      },
      {
        title: 'Largest Contentful Paint',
        url:
          'https://web.dev/lighthouse-largest-contentful-paint/#how-to-improve-your-lcp-score',
      },
      {
        title: 'Time to interactive',
        url: 'https://web.dev/interactive/#how-to-improve-your-tti-score',
      },
      {
        title: 'Total Blocking Time',
        url:
          'https://web.dev/lighthouse-total-blocking-time/#how-to-improve-your-tbt-score',
      },
      {
        title: 'Cumulative Layout Shift',
        url: 'https://web.dev/cls/#how-to-improve-cls',
      },
    ];
    return obj.find(
      (value) => value.title.toLowerCase() == content.toLowerCase(),
    );
  };

  export const getColor = (tempScore) => {
    const score = parseInt(tempScore * 100);
    let color = '#f9a02e';
    if (score < 50) color = '#f24c40';
    if (score > 89) color = '#0ace6b';
    return color;
  };

  export const convertToKib = (value) => {
    if (typeof value === 'number') {
      return (value / 1000).toFixed(2) + ' KiB';
    } else {
      return '';
    }
  };

  export const compileDateVariable = (d) => {
    let date = moment(new Date(d));
    return date.format('MMMM Do YYYY, h:mm:ss a');
  }

  export const timeConversion = (duration) => {
    if (duration === 0) {
      return duration + ' ms';
    } else {
      const portions = [];
  
      const msInHour = 1000 * 60 * 60;
      const hours = Math.trunc(duration / msInHour);
      if (hours > 0) {
        portions.push(hours + 'h');
        duration = duration - hours * msInHour;
      }
  
      const msInMinute = 1000 * 60;
      const minutes = Math.trunc(duration / msInMinute);
      if (minutes > 0) {
        portions.push(minutes + 'm');
        duration = duration - minutes * msInMinute;
      }
  
      const seconds = Math.trunc(duration / 1000);
      if (seconds > 0) {
        portions.push(seconds + 's');
      }
      if (portions.length === 0) {
        return duration.toFixed(0) + ' ms';
      } else return portions.join(' ');
    }
  };
  